import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import styles from "./InfoDropdown.module.scss";
import { ReactComponent as LocationIcon } from "../../../assets/svg/descriptionIcon.svg";
import { ReactComponent as DateIcon } from "../../../assets/svg/locationIcon.svg";
import { ReactComponent as DescriptionIcon } from "../../../assets/svg/dateIcon.svg";
import { ReactComponent as Arrow } from "../../../assets/svg/arrow.svg";
import { motion } from "framer-motion";
import moment from "moment";

const InfoDropdown = (props) => {
  const history = useHistory();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const formattedEndDate =
    props?.endDate && moment(props.endDate).format("DD-MM-YYYY");
  return (
    <motion.div
      initial={{
        opacity: props.show ? 1 : 0,
        height: props.show ? "auto" : 0,
        visibility: props.show ? "visible" : "hidden",
      }}
      animate={{
        opacity: props.show ? 1 : 0,
        height: props.show ? "auto" : 0,
        visibility: props.show ? "visible" : "hidden",
      }}
      className={`${styles.container}`}
    >
      <div onClick={() => history.push(props.history)}>
        <img src={props.image} alt={"Img"} />
      </div>
      <div className={styles.infoContainer}>
        <div
          className={`${dropdownOpen ? styles.opened : ""} ${styles.itemInfo}`}
          onClick={() => setDropdownOpen(!dropdownOpen)}
        >
          <DescriptionIcon />
          <h4>{props.name || "No hay nombre"}</h4>
          <Arrow className={styles.arrow} />
        </div>
        {dropdownOpen ? (
          <motion.div initial={{ height: "0px" }} animate={{ height: "auto" }}>
            {" "}
            <div className={styles.itemInfo}>
              <LocationIcon />
              <h4>{props.zone || "No hay zona"}</h4>
            </div>
            <div className={styles.itemInfo}>
              <DateIcon />
              <h4>
                {props.endDate ? (
                  <>
                    <span>Cierre</span> {formattedEndDate}
                  </>
                ) : (
                  "No hay fecha"
                )}
              </h4>
            </div>
          </motion.div>
        ) : null}
      </div>
    </motion.div>
  );
};

export default InfoDropdown;
